import { render, staticRenderFns } from "./AnalyticsTable.vue?vue&type=template&id=16bfd8c8&scoped=true"
import script from "./AnalyticsTable.vue?vue&type=script&lang=js"
export * from "./AnalyticsTable.vue?vue&type=script&lang=js"
import style0 from "./AnalyticsTable.vue?vue&type=style&index=0&id=16bfd8c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bfd8c8",
  null
  
)

export default component.exports